export const BUY_CAPACITY = 'buy-capacity'
export const EDIT_CABLE = 'edit-cable'
export const REPORT_ISSUE = 'report-issue'
export const CREATE_ALERT = 'create-alert'
